import { isEmpty } from '../../../utilities/GeneralUtils'

export const findSearchTermInResults = function (searchTerm, searchResults) {
  let result = null
  if (!isEmpty(searchTerm) && !isEmpty(searchResults)) {
    for (const searchResult of searchResults) {
      if (searchTerm.toLowerCase() === searchResult.name.toLowerCase()) {
        result = searchResult
        break
      }
    }
  }
  // } else if (!isEmpty(searchTerm) && !isEmpty(lastSearch)) {
  //   let st = getCurrentSearchTerm(lastSearch)
  //   if (searchTerm === st) {
  //     result = lastSearch.selectedSearchObj
  //   }
  // }

  return result
}
